import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import useAxios from "axios-hooks";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useSetRecoilState } from "recoil";
import { useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Card from "components/card/Card";
import { toastState } from "atoms/toastState";
import { Validation_MobileNumber } from "utils/validations";
import { Validation_Name } from "utils/validations";
import { Validation_Name_Req } from "utils/validations";
import { Validation_PinCode_Req } from "utils/validations";
import { Validation_MobileNumber_Req } from "utils/validations";
import { Validation_Address_Req } from "utils/validations";
import { Validation_State_Req } from "utils/validations";
import { Validation_City } from "utils/validations";
import { Validation_City_Req } from "utils/validations";
import { Validation_Country_Req } from "utils/validations";
import { Validation_PinCode } from "utils/validations";
import { Validation_Address } from "utils/validations";
import { Validation_State } from "utils/validations";
import { Validation_Country } from "utils/validations";
import { StationInputFields } from "../variables/InputFields";
import { getGridRulesFromIndex } from "utils/utils";
import logger from "infra/logger";
import { loggedInUserState } from "atoms/loggedInUserState";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import { onlyAdmins } from "utils/accessLevels";

const inputFields = [
  "Name",
  "Description",
  "Address",
  "Contact",
  "PostalCode",
  "City",
  "State",
  "Country",
];

const StationOverView = (props) => {
  const loggedInUser = useRecoilValue(loggedInUserState);
  const navigate = useNavigate();
  const setToast = useSetRecoilState(toastState);
  const [pinCode, setPinCode] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [cities, setCities] = useState([]);

  // axios requests
  const [{ d, loading, error }, createStation] = useAxios(
    { method: "POST", url: `/api/locations/create` },
    { manual: true }
  );
  const [
    { data: updateData, loading: updateLoading, error: updateError },
    updateStaton,
  ] = useAxios(
    { method: "PATCH", url: `/api/locations/update/${props?.id}` },
    { manual: true }
  );

  // validation schemas
  const updateSchema = yup.object().shape({
    Name: Validation_Name,
    PostalCode: Validation_PinCode,
    Contact: Validation_MobileNumber,
    Address: Validation_Address,
    // Description: Validation_Descrption,
    State: Validation_State,
    City: Validation_City,
    Country: Validation_Country,
  });
  const createSchema = yup.object().shape({
    Name: Validation_Name_Req,
    PostalCode: Validation_PinCode_Req,
    Contact: Validation_MobileNumber_Req,
    Address: Validation_Address_Req,
    // Description: Validation_Descrption_Req,
    State: Validation_State_Req,
    City: Validation_City_Req,
    Country: Validation_Country_Req,
  });

  const validationSchema = props?.id ? updateSchema : createSchema;

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  // function to handle update or create

  const createHandler = async () => {
    logger.log("createHandler");
    const formValues = getValues();
    let data = {};
    if (formValues.Name.trim() !== "") {
      data["Name"] = formValues.Name.trim();
    }
    if (
      formValues.PostalCode.trim() !== "" &&
      formValues.PostalCode.trim().length === 6
    ) {
      data["PostalCode"] = formValues.PostalCode.trim();
    }
    if (
      formValues.Contact.trim() !== "" &&
      formValues.Contact.trim().length === 10
    ) {
      data["Contact"] = formValues.Contact.trim();
    }
    if (formValues.Address.trim() !== "") {
      data["Address"] = formValues.Address.trim();
    }
    // if (formValues.Description.trim() !== "") {
    //   data["Description"] = formValues.Description.trim();
    // }
    if (formValues.State.trim() !== "") {
      data["State"] = formValues.State.trim();
    }
    if (formValues.City.trim() !== "") {
      data["City"] = formValues.City.trim();
    }
    // if (formValues.Country.trim() !== "") {
    //   data["Country"] = formValues.Country.trim();
    // }
    if (!props?.id && Object.keys(data).length >= 6) {
      try {
        const response = await createStation({ data: data });
        setToast({
          isOpen: true,
          title: "ChargingStation Created successfully",
          status: "success",
        });
        //navigate to view cs
        console.log(response)
        navigate("/admin/locations/view/" + response.data.data.Id + "/overview");
      } catch (error) {
        const err = error?.response?.data?.error;

        logger.log(error);
        setToast({
          isOpen: true,
          title: "Error occured when creating ChargingStation",
          description: err ? err : null,
          status: "error",
        });
      }
    } else {
      setToast({
        isOpen: true,
        title: "Enter all the fields to create ChargingStation",
        status: "warning",
        position: "top",
      });
    }
  };

  const updateHandler = async () => {
    const formValues = getValues();
    let udata = {};
    if (
      formValues.Name.trim() !== "" &&
      formValues.Name.trim() !== props.data.Name
    ) {
      udata["Name"] = formValues.Name.trim();
    }
    if (
      formValues.PostalCode.trim() !== "" &&
      formValues.PostalCode.trim().length === 6 &&
      formValues.PostalCode.trim() !== props.data.PostalCode
    ) {
      udata["PostalCode"] = formValues.PostalCode.trim();
    }
    if (
      formValues.Contact.trim() !== "" &&
      formValues.Contact.trim().length === 10 &&
      "+91" + formValues.Contact.trim() !== props.data.Contact
    ) {
      udata["Contact"] = formValues.Contact.trim();
    }
    if (
      formValues.Address.trim() !== "" &&
      formValues.Address.trim() !== props.data.Address
    ) {
      udata["Address"] = formValues.Address.trim();
    }
    // if (
    //   formValues.Description.trim() !== "" &&
    //   formValues.Description.trim() !== props.data.Description
    // ) {
    //   udata["Description"] = formValues.Description.trim();
    // }
    if (
      formValues.State.trim() !== "" &&
      formValues.State.trim() !== props.data.State
    ) {
      udata["State"] = formValues.State.trim();
    }
    if (
      formValues.City.trim() !== "" &&
      formValues.City.trim() !== props.data.City
    ) {
      udata["City"] = formValues.City.trim();
    }
    // if (
    //   formValues.Country.trim() !== "" &&
    //   formValues.Country.trim() !== props.data.Country
    // ) {
    //   udata["Country"] = formValues.Country.trim();
    // }
    if (props?.id && Object.keys(udata).length > 0) {
      try {
        const response = await updateStaton({ data: udata });
        setToast({
          isOpen: true,
          title: "ChargingStation updated successfully",
          status: "success",
        });
        await props.getStation();
      } catch (error) {
        const err = error?.response?.data?.error;
        setToast({
          isOpen: true,
          title: "Error occured when updating ChargingStation",
          description: err ? err : null,
          status: "error",
        });
      }
    } else {
      setToast({
        isOpen: true,
        title: "Nothing new to update",
        status: "warning",
        position: "top",
      });
    }
  };

  // set city handler — selection fills the text input then resets the dropdown
  const cityHandler = (e) => {
    const city = e.target.value;
    setValue("City", city, { shouldValidate: true });
    setSelectedCity(""); // reset dropdown so the input is the visible value
  };

  const pinCodeHandler = (e) => {
    logger.log(e.target.value);
    if (e.target.value.length === 6) {
      setPinCode(e.target.value);
    } else if (e.target.value.length > 6) {
      setPinCode("");
    }
  };

  const fetchPincodeData = async () => {
    const formValues = getValues();
    logger.log("printing formvalues pincode" + formValues.PostalCode);
    try {
      const response = await axios.get(
        `https://api.postalpincode.in/pincode/${formValues.PostalCode}`
      );
      if (response.status === 200) {
        const data = response.data;
        console.log(data);
        if (data && data[0] && data[0]?.PostOffice && data[0]?.PostOffice[0]) {
          const postOffice = data[0].PostOffice[0];
          const cityNames = response.data[0].PostOffice.map(
            (postOffice) => postOffice.Name
          );
          setCities(cityNames);
          setValue("State", postOffice.State);
          setValue("Country", postOffice.Country);
        }
      } else {
        setCities([]);
      }
    } catch (error) {
      logger.log(error);
      setCities([]);
    }
  };

  useEffect(() => {
    if (pinCode.length === 6) {
      fetchPincodeData();
    }
    if (pinCode.length > 6) {
      setCities([]);
    }
  }, [pinCode]);

  useEffect(() => {
    if (props?.id && props?.data) {
      inputFields.forEach((fieldName) => {
        if (props?.data && props?.data[fieldName]) {
          if (fieldName === "Contact") {
            const str = props.data[fieldName];
            let phoneNumber = str.slice(-10); //use only last 10 characters
            setValue(fieldName, phoneNumber);
          } else {
            setValue(fieldName, props.data[fieldName]);
            if (fieldName === "PostalCode") {
              fetchPincodeData();
            }
            // do not pre-select in the dropdown; value is shown in the text input only
          }
        }
      });
    }
  }, [props?.data]);
  return (
    <Card w="100%" px={{ base: "12px", md: "20px" }}>
      <Box display="flex" justifyContent="center">
        <form style={{ width: "100%", maxWidth: "900px" }}>
          <Grid
            templateAreas={{
              base: `"one"
                     "two"
                     "three"
                     "four"
                     "five"
                     "six"
                     "seven"
                     "eight"`,
              md: `"one one one one one one"
                   "two two two two two two"
                   "three three four four five five"
                   "six six seven seven eight eight"`
            }}
            mr={{ base: "0", md: "20px" }}
            gridTemplateRows={{ base: "repeat(8, auto)", md: "repeat(4, auto)" }}
            gridTemplateColumns={{ base: "1fr", md: "repeat(6, 1fr)" }}
            gap={{ base: 3, md: 4 }}
            w="100%"
          >
            {StationInputFields.map((item, index) => {
              const rules = getGridRulesFromIndex(index);
              return (
                <GridItem area={rules.area} key={index}>
                  <Flex
                    key={index}
                    mb="20px"
                    alignItems="center"
                    w={"100%"}
                    justifyContent={"center"}
                  >
                    <Controller
                      name={item.name}
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <FormControl isRequired isInvalid={errors[item.name]}>
                          <FormLabel fontSize={20}>{item.label}</FormLabel>
                          {item.type == "select" ? (
                            <Box display="flex" flexDirection="column" gap={2}>
                              <Input
                                {...field}
                                focusBorderColor="#f57d36"
                                fontSize="sm"
                                placeholder={item.placeholder}
                                width="100%"
                                minW={{ base: "auto", md: "250px" }}
                                height="50px"
                              />
                              <Text fontSize="xs" color="gray.500" lineHeight="short">
                                Enter the city or town name directly, or select one from the
                                list below after entering your postal code.{" "}
                                <Text as="span" color="orange.400" fontWeight="semibold">
                                  Use only city or town names — area or locality names are
                                  not accepted.
                                </Text>
                              </Text>
                              {cities.length > 0 && (
                                <Select
                                  value={selectedCity}
                                  onChange={(e) => cityHandler(e)}
                                  focusBorderColor="#f57d36"
                                  fontSize="xs"
                                  width="100%"
                                  minW={{ base: "auto", md: "250px" }}
                                  height="36px"
                                >
                                  <option value="">Select city from list</option>
                                  {cities.map((city, index) => (
                                    <option key={index} value={city}>
                                      {city}
                                    </option>
                                  ))}
                                </Select>
                              )}
                            </Box>
                          ) : item.label !== "Address" ? (
                            <Input
                              disabled={
                                item.label == "State" || item.label == "Country"
                              }
                              {...field}
                              focusBorderColor="#f57d36"
                              fontSize={rules?.fontSize || "sm"}
                              fontWeight={rules?.fontWeight || "unset"}
                              textAlign={rules?.textAlign || "unset"}
                              onInput={
                                item.label === "Postal Code"
                                  ? (e) => pinCodeHandler(e)
                                  : null
                              }
                              placeholder={item.placeholder}
                              width="100%"
                              minW={{ base: "auto", md: "250px" }}
                              height="50px"
                              type={item.type}
                              required
                              {...(item.type === "number"
                                ? { required: true }
                                : null)}
                            />
                          ) : (
                            <Textarea
                              {...field}
                              focusBorderColor="#f57d36"
                              placeholder={item.placeholder}
                              minHeight={40}
                              width="100%"
                              required
                            />
                          )}

                          <FormHelperText color={"#f57d36"}>
                            {item.helper}
                          </FormHelperText>
                          <FormErrorMessage mb={"20px"}>
                            {errors[item.name] && errors[item.name].message}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    />
                  </Flex>
                </GridItem>
              );
            })}
          </Grid>
          {/* </SimpleGrid> */}
        </form>
      </Box>

      <Flex justifyContent="center" mt={4}>
        <RoleBasedRender roles={onlyAdmins}>
          <Button
            bgColor={"#f57d36"}
            _hover={{ bgColor: "#d44e00" }}
            color="white"
            size="md"
            width={{ base: "100%", sm: "60%", md: "40%", lg: "20%" }}
            isLoading={loading || updateLoading}
            onClick={
              props?.id
                ? handleSubmit(updateHandler)
                : handleSubmit(createHandler)
            }
          >
            {props.buttonTitle}
          </Button>
        </RoleBasedRender>
      </Flex>
    </Card>
  );
};

export default StationOverView;
